import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step4Identity = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        identityType: '0',
        identityNumber: '',
        confirmIdentityNumber: '', // For validation
        captcha: ''
    });

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const dbData = res.data.data;
                    setFormData(prev => ({
                        ...prev,
                        identityType: dbData.identity_type || '0',
                        identityNumber: dbData.identity_number || '',
                        confirmIdentityNumber: dbData.identity_number || '' // Pre-fill confirm
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.identityNumber !== formData.confirmIdentityNumber) {
            alert("Identity Number and Confirm Identity Number must match.");
            return;
        }

        if (formData.identityType === '0') {
            alert("Please select an Identity Type.");
            return;
        }

        if (!window.confirm('Are you sure you want to submit this section?')) {
            return;
        }

        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 4,
                stepData: formData,
                nextStepNumber: 5
            });

            if (res.data.success) {
                refreshUser(5);
                navigate('/services/counselling/dashboard/apaar-id');
            }
        } catch (err) {
            alert("Error saving data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div className="container-fluid contentmid" style={{ padding: 0 }}>
                    
                    <h4>पहचान विवरण (Identity Details)</h4>
                    
                    <div className="alert alert-danger" style={{margin: '10px 0'}}>
                        <strong>Note:</strong> Candidates who have verified their identities through methods other than Aadhaar are required to upload their identity proof in the Upload Section.
                        <br/>
                        <strong>नोट:</strong> जिन उम्मीदवारों ने आधार के अलावा अन्य तरीकों से अपनी पहचान सत्यापित की है, अपना पहचान प्रमाण अपलोड करना आवश्यक है।
                    </div>

                    <div className="form-horizontal formLabel">
                        
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>पहचान के प्रकार (Identity Type)</span>
                            </label>
                            <div className="col-sm-4">
                                <select 
                                    name="identityType" 
                                    className="form-control" 
                                    value={formData.identityType} 
                                    onChange={handleChange}
                                >
                                    <option value="0">--Select--</option>
                                    <option value="PAN">PAN Card</option>
                                    <option value="School ID">School ID Card</option>
                                    <option value="Passport">Passport</option>
                                    <option value="Voter ID">Voter ID</option>
                                    <option value="Ration Card">Ration Card with Photograph</option>
                                    <option value="Bank Passbook">Bank Passbook with Photograph</option>
                                    <option value="Driving License">Driving License</option>
                                    <option value="Aadhaar">Aadhaar (Not preferred here)</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>पहचान संख्या (Identification Number)</span>
                            </label>
                            <div className="col-sm-4">
                                <input 
                                    name="identityNumber" 
                                    type="text" 
                                    className="form-control" 
                                    value={formData.identityNumber} 
                                    onChange={handleChange}
                                    required 
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>पहचान संख्या की पुष्टि करें (Confirm Identification Number)</span>
                            </label>
                            <div className="col-sm-4">
                                <input 
                                    name="confirmIdentityNumber" 
                                    type="text" 
                                    className="form-control" 
                                    value={formData.confirmIdentityNumber} 
                                    onChange={handleChange}
                                    required 
                                />
                            </div>
                        </div>

                        <br />

                        {/* CAPTCHA */}
                        <div id="ctl00_ContentPlaceHolder1_pnlFinalSubmit">
                            <h4>CAPTCHA</h4>
                            <div className="form-group">
                                <label className="control-label col-sm-4">
                                    Enter CAPTCHA as shown below <span className="text-primary">(case sensitive)</span>
                                </label>
                                <div className="col-sm-4">
                                    <input name="captcha" type="text" className="form-control" value={formData.captcha} onChange={handleChange} required />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-4">CAPTCHA</label>
                                <div className="col-sm-4">
                                     <div style={{display:'inline-block', verticalAlign:'middle'}}>
                                        <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px', borderWidth:'0px'}} />
                                     </div>
                                     <div style={{display:'inline-block', verticalAlign:'middle', marginLeft:'10px'}}>
                                        <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{height:'30px', width:'30px', cursor:'pointer'}} />
                                     </div>
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <div className="col-sm-12 text-center" style={{marginTop:'20px'}}>
                                    <button 
                                        type="button" 
                                        className="btn btn-warning" 
                                        onClick={() => navigate('/services/counselling/dashboard/pwd-details')} 
                                        style={{marginRight:'10px'}}
                                    >
                                        Back
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary" 
                                        onClick={handleSubmit} 
                                        disabled={loading}
                                    >
                                        {loading ? 'Saving...' : 'Submit & Next'}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step4Identity;